import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../utils/api";

// Async Thunk for Category API Call
export const fetchCategories = createAsyncThunk(
  "category/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get("/categories");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const fetchCategoryProducts = createAsyncThunk(
  "category/fetchCategoryProducts",
  async ({ categoryId, page = 1, perPage = 10 }, { rejectWithValue }) => {
    try {      
      const response = await API.get(`/categoryproduct/${categoryId}?page=${page}&perPage=${perPage}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: [],
    cat_products: [],
    cat_loading: false,
    cat_error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.cat_loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.cat_loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.cat_loading = false;
        state.cat_error = action.payload;
      })
      .addCase(fetchCategoryProducts.pending, (state) => {
        state.cat_loading = true;
      })
      .addCase(fetchCategoryProducts.fulfilled, (state, action) => {
        state.cat_loading = false;
        state.cat_products = action.payload;
      })
      .addCase(fetchCategoryProducts.rejected, (state, action) => {
        state.cat_loading = false;
        state.cat_error = action.payload;
      });
  },
});

export default categorySlice.reducer;
